module.exports = __webpack_public_path__ + "img/lg_ring_g_s_1_1@2x.e7b115c6.png";